import React from "react";
import { IOrderStatusOverviewProps } from "./types";
import DriverDetailsBanner from "./DriverDetailsBanner";
import { useTranslation } from "react-i18next";

const OrderStatusOverview: React.FC<IOrderStatusOverviewProps> = ({
  status,
  mainTitle,
  subtitle,
  timeInfo,
  showDriverInfoBanner,
  isArrived,
}) => {
  const isBottomSubtitle = status === "completed" || status === "cancelled";
  const cardClass = `border-b border-gray-200 bg-white p-[16px] mb-1${
    !isBottomSubtitle ? " rounded-t-lg" : ""
  }`;
  const { t } = useTranslation("webReceipt");
  return (
    <div className={cardClass}>
      <div className="flex flex-row items-end w-full">
        <div className="flex flex-col justify-end flex-1 min-w-0">
          {!isBottomSubtitle && subtitle && (
            <div className="text-base font-semibold text-mineshaft-900 mt-4 mb-4">
              {subtitle}
            </div>
          )}
          <div className="text-3xl font-bold leading-none mb-4 break-words">
            {mainTitle}
          </div>
          {isBottomSubtitle && subtitle && (
            <div className="text-base font-semibold text-mineshaft-900 mt-2 mb-4">
              {subtitle}
            </div>
          )}
        </div>
        {/* {timeInfo && (
          <div className="flex flex-col items-end justify-end min-w-[120px] ml-3 pr-4 pb-4">
            <span className="text-base font-normal text-neutral-900 whitespace-nowrap">
              {timeInfo}
            </span>
          </div>
        )} */}
        {timeInfo && !isArrived && (
          <div className="flex flex-col items-end justify-end min-w-[120px] ml-3 pr-4 pb-4">
            <span className="text-base font-normal text-neutral-900 whitespace-nowrap">
              {timeInfo}
            </span>
          </div>
        )}
      </div>
      {showDriverInfoBanner && <DriverDetailsBanner />}
      {!["cancelled", "completed"].includes(status) && (
        <div className="text-center text-base font-semi-bold text-mineshaft-700">
          {t("common_pageRefreshNote")}
        </div>
      )}
    </div>
  );
};

export default OrderStatusOverview;
